import catalog from "./toolkitCatalog.json";
import type { ToolCategory, ToolDefinition } from "./types";
export const toolkitWorkbenchLoaders: Record<
  string,
  NonNullable<ToolDefinition["loader"]>
> = {
  "table-split": () => import("./pages/workbenches/TableWorkbenches"),
  "stratified-sample": () => import("./pages/workbenches/TableWorkbenches"),
  "gantt-chart": () => import("./pages/workbenches/TableWorkbenches"),
  flashcards: () => import("./pages/workbenches/LearningPrintTool"),
  "answer-sheet": () => import("./pages/workbenches/LearningPrintTool"),
  "matrix-workbench": () => import("./pages/workbenches/MathWorkbenches"),
  "probability-distribution": () =>
    import("./pages/workbenches/MathWorkbenches"),
  "bibliography-converter": () =>
    import("./pages/workbenches/BibliographyTool"),
};

// Metadata is shared by runtime discovery, tool forms and generated SEO pages.
export const toolkitDefinitions: ToolDefinition[] = catalog.map((entry) => ({
  ...entry,
  category: entry.category as ToolCategory,
  status: "available",
  localOnly: true,
  loader:
    toolkitWorkbenchLoaders[entry.id] ||
    (() => import("./pages/EverydayToolkitTool")),
}));
